<dx-list [dataSource]="selectablePeople"
         displayExpr="fullName"
         [searchEnabled]="true"
         searchExpr="fullName"
         searchMode="contains"
         selectionMode="multiple"
         [showSelectionControls]="true"
         showScrollbar="always"
         pageLoadMode="scrollBottom"
         (onSelectionChanged)="handleSelectionChange($event)">
    <adapt-mention-person *dxTemplate="let person of 'item'"
                          [person]="person"></adapt-mention-person>
</dx-list>
